import ContactCard, { LayoutType } from "../common/ContactCard";
import { ContactInfo } from "../../types/listing";

export type ContactCardsProps = {
  contacts: ContactInfo[];
  discoveryTooltip?: string;
  isLastDiscoveryTooltip?: boolean;
  onDiscoveryTooltipNextClick?: () => void;
  onToggleContactIsDisabled: (
    contact: ContactInfo,
    isDisabled: boolean
  ) => void;
  isContactEditingDisabled?: boolean;
  contactCardLayoutType?: LayoutType;
};

const ContactCards = ({
  contacts,
  discoveryTooltip,
  isLastDiscoveryTooltip,
  onDiscoveryTooltipNextClick,
  onToggleContactIsDisabled,
  isContactEditingDisabled = false,
  contactCardLayoutType = LayoutType.horizontal,
}: ContactCardsProps) => {
  return (
    <div className="contact-cards lg:flex flex-col h-full min-w-[300px]">
      <div className={contactCardLayoutType === LayoutType.horizontal ? "flex flex-col gap-2 w-full" : "inline-flex flex-wrap gap-4 w-full"}>
        {contacts.map(
          (contact, index) =>
            index <= 3 && (
              <ContactCard
                {...(discoveryTooltip &&
                  index === 0 && {
                    discoveryTooltip,
                    isLastDiscoveryTooltip,
                    onDiscoveryTooltipNextClick,
                  })}
                isEditingDisabled={isContactEditingDisabled}
                contact={contact}
                layoutType={contactCardLayoutType}
                onToggleIsDisabled={(isDisabled) => {
                  onToggleContactIsDisabled(contact, isDisabled);
                }}
                key={`contact-card-${contact.id}`}
              />
            )
        )}
      </div>
    </div>
  );
};

export default ContactCards;
